/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-submodule-imports

import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  CommonExternalSharedModule,
  ExtConfirmationDialogComponent,
  ExtMessageDialogComponent,
} from '@gh/common-external-shared';

import { CommonSharedModule } from '@gh/common-shared';

import { CommonSharedDataModule } from '@gh/common-shared-data';
import { KEYCLOAK_AUTH_MODE, KEYCLOAK_WITH_MOCK_AUTH_MODE, MOCK_AUTH_MODE, MOCK_BACKEND_DEV_MODULE } from '@gh/config';
import { CoreDataModule, CoreMockDataModule } from '@gh/core-data';

import { CoreMessagesModule } from '@gh/core-messages';
import { CoreTypeModule } from '@gh/core-type';
import { CoreUiCommonModule, CoreUiDialogsModule, CoreUiWaitingModule } from '@gh/core-ui';
import { SupplierSharedModule } from '@gh/supplier-shared';
import { SupplierSharedDataModule } from '@gh/supplier-shared-data';

import { AUTH_MODE } from '@gh/config';

import {
  SupplierAppComponent,
  SupplierCalendarComponent,
  SupplierInvoicesListComponent,
  SupplierOfficeInfoComponent,
  SupplierOfficeInfoDialogComponent,
  SupplierOrderInfoDialogComponent,
  SupplierPurchaseOrderListComponent,
  SupplierSharedDocsListComponent,
} from './components';

import { SupplierAuthConfigModule, SupplierHttpClientConfigModule, SupplierMlsConfigModule } from './config';
import { SupplierBootstrapService } from './config/supplier-bootstrap.service';

import { SUPPLIER_MOCK_DATA } from './mock/supplier-mock-data';
import {
  SupplierCalendarBusinessService,
  SupplierInvoicesListBusinessService,
  SupplierOfficeActivator,
  SupplierPurchaseOrderListBusinessService,
  SupplierSharedDocsListBusinessService,
} from './resources';

import { SupplierAppRoutingModule } from './supplier-app-routing.module';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,

    // core modules
    CoreMessagesModule,
    CoreDataModule.forRoot(),
    CoreTypeModule.forRoot(),
    CoreUiCommonModule.forRoot(),
    CoreUiDialogsModule.forRoot({
      standardSet: {
        messageDialogType: ExtMessageDialogComponent,
        confirmationDialogType: ExtConfirmationDialogComponent,
      },
    }),
    CoreUiWaitingModule.forRoot(),

    // common modules
    CommonSharedDataModule.forRoot(),
    CommonSharedModule.forRoot(),
    CommonExternalSharedModule.forRoot(),

    // configuration modules
    (AUTH_MODE === KEYCLOAK_AUTH_MODE ? SupplierAuthConfigModule.useKeycloak() :
      AUTH_MODE === KEYCLOAK_WITH_MOCK_AUTH_MODE ? SupplierAuthConfigModule.useKeycloakWithMock() :
        AUTH_MODE === MOCK_AUTH_MODE ? SupplierAuthConfigModule.useMock() : SupplierAuthConfigModule.none()),

    SupplierHttpClientConfigModule,
    SupplierMlsConfigModule,

    // supplier modules
    SupplierSharedDataModule.forRoot(),
    SupplierSharedModule.forRoot(),
    SupplierAppRoutingModule,

    MOCK_BACKEND_DEV_MODULE ? CoreMockDataModule.withMockData(SUPPLIER_MOCK_DATA) : [],
  ],
  providers: [
    SupplierBootstrapService, {
      provide: APP_INITIALIZER,
      useFactory: (bootstap: SupplierBootstrapService) => () => bootstap.load(),
      deps: [SupplierBootstrapService],
      multi: true,
    },
    SupplierOfficeActivator,
    SupplierPurchaseOrderListBusinessService,
    SupplierSharedDocsListBusinessService,
    SupplierCalendarBusinessService,
    SupplierInvoicesListBusinessService,
  ],
  declarations: [
    SupplierPurchaseOrderListComponent,
    SupplierAppComponent,
    SupplierOfficeInfoComponent,
    SupplierOfficeInfoDialogComponent,
    SupplierSharedDocsListComponent,
    SupplierCalendarComponent,
    SupplierInvoicesListComponent,
    SupplierOrderInfoDialogComponent,
  ],
  entryComponents: [
    SupplierOfficeInfoDialogComponent,
    SupplierOrderInfoDialogComponent,
  ],
  bootstrap: [SupplierAppComponent],
})
export class SupplierAppModule {
}
